import ApiService from '../services/ApiService';
import Store from '../wrappers/Store';
import Settings from '../wrappers/Settings';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { Device as DeviceDetect } from '@capacitor/device';
export const Device = {
    async detect() {
        let { name, model, platform, operatingSystem, osVersion, manufacturer, webViewVersion } = await DeviceDetect.getInfo();
        const devicePlatform = Settings.electron ? 'electron' : platform;
        const device = { name, model, platform: devicePlatform, operatingSystem, osVersion, manufacturer, webViewVersion };
        if (devicePlatform === 'android' || devicePlatform === 'ios') {
            const deviceId = await DeviceDetect.getId();
            device.uuid = deviceId.identifier;
        }
        if (devicePlatform === 'web') {
            const fp = await FingerprintJS.load();
            const result = await fp.get();
            device.uuid = result.visitorId;
        }
        if (devicePlatform === 'electron') {
            device.uuid = await Settings.electron.invoke('elUuid');
            const electronData = await Settings.electron.invoke('elInfo');
            if (electronData) {
                device.electron = electronData;
            }
        }
        return device;
    },
    get() {
        return Store.get('device') || undefined;
    },
    set(device) {
        Store.set('device', device);
        ApiService.setDeviceUuidHeader(device.uuid || null);
        ApiService.setDevicePlatformHeader(device.platform || null);
    },
    isWeb() {
        const device = this.get();
        return device?.platform === 'web';
    },
    isAndroid() {
        const device = this.get();
        return device?.platform === 'android';
    },
    isIOS() {
        const device = this.get();
        return device?.platform === 'ios';
    },
    isMobile() {
        const device = this.get();
        return device?.platform === 'android' || device?.platform === 'ios';
    },
    isElectron() {
        const device = this.get();
        return device?.platform === 'electron';
    }
};
export default Device;
//# sourceMappingURL=Device.js.map